// Provisioned by scripts/build-map-styles.mjs — do not edit by hand.
// Base styles with the place-of-interest and similar label layers left out,
// shared by the live map and the static previews.

export type MapTheme = "light" | "dark";

/** "<owner>/<style id>" per theme. */
export const MAP_STYLE_IDS: Record<MapTheme, string> = {
  "light": "therealkieran/cmtlw3mjk00db01sq6etccaj7",
  "dark": "therealkieran/cmtlw3mzf000001ss9m7z6640"
};

export const mapStyleUrl = (theme: MapTheme): string => `mapbox://styles/${MAP_STYLE_IDS[theme]}`;
